export default __webpack_public_path__ + "static/media/VacancyRewards.0c3dd1ee.webp";